import { __decorate, __metadata } from "tslib";
import { Component, Input, Output } from 'angular-ts-decorators';
import template from './product-filter-group.component.html';
var ProductFilterGroupComponent = (function () {
    function ProductFilterGroupComponent() {
        this.showFilters = false;
    }
    ProductFilterGroupComponent.prototype.overlayClicked = function () {
        this.showFilters = false;
    };
    ProductFilterGroupComponent.prototype.toggleFilters = function () {
        this.showFilters = !this.showFilters;
    };
    ProductFilterGroupComponent.prototype.filterChanged = function (filter) {
        this.showFilters = false;
        if (this.onFilterChange) {
            this.onFilterChange({ filterId: filter.id, filterGroup: this.filterGroup });
        }
    };
    ProductFilterGroupComponent.$inject = [];
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ProductFilterGroupComponent.prototype, "filterGroup", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Function)
    ], ProductFilterGroupComponent.prototype, "onFilterChange", void 0);
    ProductFilterGroupComponent = __decorate([
        Component({
            selector: 'productFilterGroup',
            template: template,
        })
    ], ProductFilterGroupComponent);
    return ProductFilterGroupComponent;
}());
export { ProductFilterGroupComponent };
